import * as types from '../const/action.types';
import { get, post, put } from '../api/_basic';

export function loadProviders() {
    return async (dispatch) => {
        dispatch(providersHasErrored(false, ''));
        dispatch(providersIsLoading(true));
        return get(`${process.env.REACT_APP_API_PROVIDERS}`)
            .then((response) => {
                dispatch(providersIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(providersHasErrored(false, ''));
                dispatch(loadProvidersSuccess(items));
            })
            .catch((error) => {
                dispatch(providersIsLoading(false));
                dispatch(providersHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addProvider(provider) {
    return async (dispatch) => {
        dispatch(providerIsSaving(true));
        return post(`${process.env.REACT_APP_API_PROVIDERS}`, provider)
            .then((response) => {
                dispatch(providerIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function editProvider(provider) {
    return (dispatch) => {
        dispatch(providerIsSaving(true));
        return put(`${process.env.REACT_APP_API_PROVIDERS}/${provider.id}`, provider)
            .then((response) => {
                dispatch(providerIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadProvider(id) {
    return async function(dispatch) {
        dispatch(providersHasErrored(false, ''));
        dispatch(providersIsLoading(true));
        dispatch(loadProviderSuccess({}));
        return get(`${process.env.REACT_APP_API_PROVIDERS}/${id}`)
            .then((response) => {
                dispatch(providersIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(providersHasErrored(false, ''));
                dispatch(loadProviderSuccess(item));
            })
            .catch((error) => {
                //throw error;
                dispatch(providersHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadProviderSuccess(data) {
    return {
        type: types.LOAD_PROVIDER_SUCCESS,
        data,
    };
}

export function loadProvidersSuccess(data) {
    return {
        type: types.PROVIDERS_SUCCESS,
        data,
    };
}

export function providersHasErrored(bool, message) {
    return {
        type: types.PROVIDER_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function providersIsLoading(bool) {
    return {
        type: types.PROVIDERS_IS_LOADING,
        isLoading: bool,
    };
}

export function providerIsSaving(bool) {
    return {
        type: types.PROVIDERS_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/providers.actions.js